function loadRankingResultsGrid(endpoint, questionId) {
  var request = function () {
    $.ajax({
      url: endpoint,
      dataType: 'json',
      error: function (response) {
        setTimeout(request, 5000);
      },
      success: function (data) {
        var container = $("#question-results-"+questionId);
        var maxScore = 0;
        data.forEach(function (row, index) {
          $("#option-" + index, container).html(row[0]);
          for (var i in row[1]) {
            var unit = i == "AVERAGE" ? "" : "%";
            var score = row[1][i];
            maxScore = Math.max(maxScore, score);
            $("#option-" + index + "-value-" + i, container).html(score + unit);
          }
          for (var j in row[1]) {
            var backColour = j == "AVERAGE" ? "white" : generateColour(row[1][j], maxScore);
            $("#option-" + index + "-value-" + j, container).css("background-color", backColour);
          }
        });
        $("#rank-table-loading-message", container).fadeOut('fast', function(){
          $("#rank-table-loading-message", container).css("display", "none");
          $("#rank-table-container", container).fadeIn('slow');
        });
      }
    });
  };
  request();
}
function generateColour(score, max) {
  var hue = Math.round(120 * (score / max));
  return "hsl(" + hue + ",65%,50%)";
}


/*** EXPORTS FROM exports-loader ***/
exports["loadRankingResultsGrid"] = (loadRankingResultsGrid);
exports["generateColour"] = (generateColour);